import httpCommon from "./http-common";

// Get company
const getCompany = (publicId: string) => {
  return httpCommon.get(`/v1/get/company/${publicId}`);
};

const getCompanyAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/company");
};

// Get all companies
const getAllCompanies = (businessId: number) => {
  return httpCommon.get(`/v1/get/companies/${businessId}`);
};

const getAllCompaniesAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/companies");
};

// Get company count
const getAllCompaniesCount = () => {
  return httpCommon.get("/v1/get/count/companies");
};

const getAllCompaniesCountAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/count/companies");
};

// Add company
const addCompany = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/company/${businessId}`, data);
};

const searchCompany = (businessId: number, searchTerm: string) => {
  return httpCommon.get(`/v1/search/companies/${businessId}/${searchTerm}`);
};

// Update specific company
const updateSpecificCompany = (publicId: string, data: any) => {
  return httpCommon.put(`/v1/update/company/${publicId}`, data);
};

// Delete company
const deleteCompany = (publicId: string) => {
  return httpCommon.delete(`/v1/delete/company/${publicId}`);
};

const removeCompanyFromBusiness = (businessId: number, publicId: string) => {
  return httpCommon.delete(`/v1/delete/companyBusiness/${businessId}/${publicId}`);
};

const CompanyService = {
    getCompany,
    getCompanyAsAdmin,
    getAllCompanies,
    getAllCompaniesAsAdmin,
    getAllCompaniesCount,
    getAllCompaniesCountAsAdmin,
    addCompany,
    searchCompany,
    updateSpecificCompany,
    deleteCompany,
    removeCompanyFromBusiness
};
export default CompanyService;